import { theme } from 'lib/style';
import React from 'react';
import { Tooltip } from 'react-covideo-common';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components/macro';

type BouncedProps = {
  color: string;
};

const BouncedContainer = styled.div<BouncedProps>`
  color: ${props => props.color};
  cursor: pointer;
  height: 40px;
  display: flex;
  align-items: center;
`;

const BouncedTooltip = styled.div`
  max-width: 300px;
  white-space: wrap;
  padding: 10px;
  line-height: 20px;
`;

const Bounced = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #11a694;
  word-break: break-all;
`;

type BouncedEmailProps = {
  email: string;
  bouncedEmail: string;

  tooltipPosition?: 'top' | 'bottom' | 'left' | 'right';
};

const BouncedEmail = ({
  email,
  bouncedEmail,
  tooltipPosition,
}: BouncedEmailProps) => {
  const { t } = useTranslation();
  let tooltipText = <></>;
  let color = '';

  if (!bouncedEmail || !email) return <></>;

  if (email === bouncedEmail) {
    tooltipText = (
      <BouncedTooltip>
        <Trans
          i18nKey='emailBounceMessage'
          values={{ email: bouncedEmail }}
          components={[<Bounced />]}
        />
      </BouncedTooltip>
    );
    color = theme.palette.red100;
  } else if (email !== bouncedEmail) {
    tooltipText = (
      <BouncedTooltip>
        <Trans
          i18nKey='emailUpdatedMessage'
          values={{
            oldEmail: bouncedEmail,
            newEmail: email,
          }}
          components={[<Bounced />, <Bounced />]}
        />
      </BouncedTooltip>
    );

    color = theme.palette.covideoOrange100;
  }

  return (
    <Tooltip popup={tooltipText} position={tooltipPosition || 'top'}>
      <BouncedContainer color={color}>{t('Bounced')}</BouncedContainer>
    </Tooltip>
  );
};

export default BouncedEmail;
